import { Listbox } from '@headlessui/react';
import type { CountryCode } from 'libphonenumber-js';
import { forwardRef } from 'react';
import type { Key } from '../Select/Item';
import type { UsePhoneProps, UsePhoneState } from './hook/usePhone';
import { PhoneCountryDropdown } from './PhoneCountryDropdown';
import type { SupportedCountryType } from './utils';

export interface PhoneCountryListItemWrapperProps
  extends Pick<UsePhoneProps, 'disabled' | 'hasError' | 'notFound' | 'placeholder' | 'searchCountryPlaceholder'> {
  readonly formattedSelectedCountry: SupportedCountryType;
  readonly setState: React.Dispatch<React.SetStateAction<UsePhoneState>>;
  readonly phoneInputRef: React.RefObject<HTMLInputElement>;
  readonly countriesListMatcher: SupportedCountryType[];
  readonly maxVisibleContentItems?: number;
  readonly onSelectCountry: (val: Key) => void;
  readonly selectedCountry: CountryCode;
  readonly searchKey: string;
}

export const PhoneCountryListItemWrapper = forwardRef<HTMLDivElement, PhoneCountryListItemWrapperProps>(
  ({ disabled, ...props }, ref) => {
    return (
      <Listbox as="div" disabled={disabled}>
        {({ open }) => <PhoneCountryDropdown {...props} disabled={disabled} open={open} ref={ref} />}
      </Listbox>
    );
  },
);
